import { render, staticRenderFns } from "./OfertaCuenta.vue?vue&type=template&id=2c6a6e96&scoped=true"
import script from "./OfertaCuenta.vue?vue&type=script&lang=js"
export * from "./OfertaCuenta.vue?vue&type=script&lang=js"
import style0 from "./OfertaCuenta.vue?vue&type=style&index=0&id=2c6a6e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a6e96",
  null
  
)

export default component.exports